import React from "react";
import classnames from 'classnames';
import styled, { ThemeProvider } from "styled-components";
import theme from "./../../themes/default";

const Wrap = styled.div`
    display: flex;
    flex-direction: column-reverse;
    max-width: ${(props) => props.theme.sizes.maxWidth};
    padding-top: 22px;
    padding-right: 20px;
    padding-left: 20px;

    @media (min-width: 990px) {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        margin: 0 auto;
        padding-top: 90px;
        max-width: 960px;
        margin-top: 80px;
    }

    @media (min-width: 1320px) {
        max-width: 1280px;
    }

    &.account {
        @media (min-width: 990px) {
            padding-top: 50px;
        }
    }
`;

export default function ContentWrap(props) {
    return (
        <ThemeProvider theme={theme}>
            <Wrap className={classnames({ 'account': props.mode === "account" })}>
                {props.children}
            </Wrap>
        </ThemeProvider>
    );
}
